/**
 * Date Utility Functions
 * 
 * Helper functions for formatting dates.
 */

import { format } from "date-fns";
import { id as idLocale } from "date-fns/locale";

/**
 * Format date to Indonesian format (DD/MM/YYYY)
 */
export function formatDate(dateString: string | null): string {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    return format(date, "dd/MM/yyyy", { locale: idLocale });
  } catch {
    return "-";
  }
}

